import "./Services.css";

function ServiceCard({ service, service2, photo, alt_info, isLogo }) {
  return (
    <article className={`service-card group ${isLogo ? "service-card--logo" : ""}`}>
      <div className="service-card-text">
        <p className="service-card-label">{service}</p>
        <h3 className="service-card-title">{service2}</h3>
      </div>

      <div
        className={`service-card-image ${isLogo ? "service-card-image--logo" : ""}`}
      >
        <img
          className={`service-card-img ${isLogo ? "service-card-img--logo" : ""}`}
          src={photo}
          alt={alt_info}
        />
      </div>
    </article>
  );
}

export default ServiceCard;
